import { createFileRoute, getRouteApi, notFound } from "@tanstack/react-router";

import { NavBar } from "@/components/client-navigation-bar";
import { CmsPage } from "@/components/cms-page";
import { fetchNavPages } from "@/lib/page-data";

const routeApi = getRouteApi("/$pageNameOrCategory_/$pageName");

const DbPage = () => {
  const { pages, page } = routeApi.useLoaderData();

  return (
    <div className="min-h-[100dvh]">
      <NavBar pages={pages} />

      <CmsPage content={page.content} />
    </div>
  );
};

export const Route = createFileRoute("/$pageNameOrCategory_/$pageName")({
  component: DbPage,
  loader: async ({ params }) => {
    const pages = await fetchNavPages();
    const page = pages.find(
      (it) =>
        it.name === decodeURIComponent(params.pageName) &&
        it.category === decodeURIComponent(params.pageNameOrCategory)
    );

    if (!page) {
      throw notFound();
    }

    return { page, pages };
  },
});
